import { Middleware } from 'redux';

import { hideLoading, LOGIN, loginError, loginSuccess, LOGIN_SUCCESS, redirectTo, setPassword, showLoading, REDIRECT_TO } from './actions';

import { toast } from 'react-toastify';
import { RootState } from '../../../store/store';
import { AuthService } from '../../../core-sdk/services/authentication';


const loginFlow: Middleware<{}, RootState> = ({ dispatch, getState }) => next => (action: any) => {

    const state = getState()
    if (action.type === LOGIN) {
        dispatch(showLoading());
        AuthService.login(state.auth.username, state.auth.password)
            .then(response => {
                AuthService.setUsername(state.auth.username);
                dispatch(loginSuccess(response.data, action.payload?.returnUrl));
                dispatch(hideLoading());
            })
            .catch(error => {
                toast.error('Login Failed, Incorrect credentials or server error!');
                dispatch(loginError('Could not login', error.status));
                dispatch(setPassword(''));
                dispatch(hideLoading());
            });
    }
    next(action);
}

const processLogin: Middleware<{}, RootState> = ({ dispatch }) => next => (action: any) => {
    if (action.type === LOGIN_SUCCESS) {
        AuthService.setToken(action.payload.access);
        AuthService.setRefreshToken(action.payload.refresh);
        toast.success('Login Success, You have successfully logged in');
        dispatch(redirectTo(action.meta ? action.meta : '/' + AuthService.getUsername()))
    }

    next(action);
}

const redirectFlow: Middleware<{}, RootState> = () => next => (action: any) => {
    if (action.type === REDIRECT_TO) {
        const url = action.payload;
        window.location.assign(url);
    }

    next(action);
}

export const authMiddleware = [loginFlow, processLogin, redirectFlow];